const validateFio = (value: string): boolean => /^[А-ЯЁа-яё-]*$/.test(value);
const validateGender = (value: string): boolean => /^[M,W]*$/.test(value);
const validateAgeValueBetween = (value: string, vm: any) => {
  const { ageFrom } = vm;
  return ageFrom.length && value.length
    ? parseInt(ageFrom, 10) < parseInt(value, 10)
    : true;
};

export { validateFio, validateGender, validateAgeValueBetween };



// WEBPACK FOOTER //
// ./src/tools/validatefio.ts